/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreditPoolInfoFromJSON, CreditPoolInfoToJSON } from './CreditPoolInfo';
import { MailboxInfoFromJSON, MailboxInfoToJSON } from './MailboxInfo';
import { QuotaInfoFromJSON, QuotaInfoToJSON } from './QuotaInfo';
/**
 * Check if a given object implements the UserInfo interface.
 */
export function instanceOfUserInfo(value) {
    if (!('uid' in value) || value['uid'] === undefined)
        return false;
    return true;
}
export function UserInfoFromJSON(json) {
    return UserInfoFromJSONTyped(json, false);
}
export function UserInfoFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brand': json['brand'] == null ? undefined : json['brand'],
        'canUseMultiMailbox': json['canUseMultiMailbox'] == null ? undefined : json['canUseMultiMailbox'],
        'customClaims': json['customClaims'] == null ? undefined : json['customClaims'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'email': json['email'] == null ? undefined : json['email'],
        'emailVerified': json['emailVerified'] == null ? undefined : json['emailVerified'],
        'linkedMailboxes': json['linked_mailboxes'] == null ? undefined : (json['linked_mailboxes'].map(MailboxInfoFromJSON)),
        'locale': json['locale'] == null ? undefined : json['locale'],
        'maxMailboxes': json['maxMailboxes'] == null ? undefined : json['maxMailboxes'],
        'name': json['name'] == null ? undefined : json['name'],
        'photoURL': json['photoURL'] == null ? undefined : json['photoURL'],
        'providerData': json['providerData'] == null ? undefined : json['providerData'],
        'purchasedCreditPools': json['purchasedCreditPools'] == null ? undefined : (json['purchasedCreditPools'].map(CreditPoolInfoFromJSON)),
        'quota': json['quota'] == null ? undefined : QuotaInfoFromJSON(json['quota']),
        'subscription': json['subscription'] == null ? undefined : json['subscription'],
        'tokensValidAfterTime': json['tokensValidAfterTime'] == null ? undefined : json['tokensValidAfterTime'],
        'uid': json['uid'],
    };
}
export function UserInfoToJSON(json) {
    return UserInfoToJSONTyped(json, false);
}
export function UserInfoToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brand': value['brand'],
        'canUseMultiMailbox': value['canUseMultiMailbox'],
        'customClaims': value['customClaims'],
        'disabled': value['disabled'],
        'displayName': value['displayName'],
        'email': value['email'],
        'emailVerified': value['emailVerified'],
        'linked_mailboxes': value['linkedMailboxes'] == null ? undefined : (value['linkedMailboxes'].map(MailboxInfoToJSON)),
        'locale': value['locale'],
        'maxMailboxes': value['maxMailboxes'],
        'name': value['name'],
        'photoURL': value['photoURL'],
        'providerData': value['providerData'],
        'purchasedCreditPools': value['purchasedCreditPools'] == null ? undefined : (value['purchasedCreditPools'].map(CreditPoolInfoToJSON)),
        'quota': QuotaInfoToJSON(value['quota']),
        'subscription': value['subscription'],
        'tokensValidAfterTime': value['tokensValidAfterTime'],
        'uid': value['uid'],
    };
}
